import http from "./http";

/* =========================
   GET ALL SUPPLIERS
========================= */
export const getSuppliers = async () => {
  const res = await http.get("suppliers?action=get_all");
  return res.data;
};

/* =========================
   GET SINGLE SUPPLIER
========================= */
export const getSupplierById = async (id) => {
  const res = await http.get(`suppliers?action=get&id=${id}`);
  return res.data;
};

/* =========================
   ADD SUPPLIER
   🔴 Backend expects: gst
========================= */
export const addSupplier = async (payload) => {
  const res = await http.post("suppliers?action=add", {
    name: payload.name,
    gst: payload.gst_no, // ✅ FIX (gst, not gst_no)
    contact_person: payload.contact_person,
    phone: payload.phone,
    email: payload.email,
    address: payload.address,
    note: payload.note,
    opening_balance: payload.opening_balance,
    opening_balance_type: payload.opening_balance_type,
    credit_limit: payload.credit_limit,
  });

  return res.data;
};

/* =========================
   UPDATE SUPPLIER
   🔴 Backend expects: gst
========================= */
export const updateSupplier = async (id, payload) => {
  const res = await http.post("suppliers?action=update", {
    id,
    name: payload.name,
    gst: payload.gst_no, // ✅ FIX
    contact_person: payload.contact_person,
    phone: payload.phone,
    email: payload.email,
    address: payload.address,
    note: payload.note,
    opening_balance: payload.opening_balance,
    opening_balance_type: payload.opening_balance_type,
    credit_limit: payload.credit_limit,
  });

  return res.data;
};

/* =========================
   DELETE SUPPLIER
========================= */
export const deleteSupplier = async (id) => {
  const res = await http.post("suppliers?action=delete", { id });
  return res.data;
};
